import { RESOURCE_MANAGEMENT, RESOURCE_MANAGEMENT_EXPORT, RESOURCE_MANAGEMENT_FILTER } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import { appendServiceNameToURL, appendServicePortToURL } from '../resources/serviceURLs';

const buildServiceURL = (service, path) => {
  const serviceURL = appendServiceNameToURL(service);
  const servicePort = appendServicePortToURL(service);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}${path}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}${path}`;
};

export const resourceManagementBaseURL = buildServiceURL(
  serviceName.PROJECT_MS,
  RESOURCE_MANAGEMENT,
);

export const getResourceMgmtBootstrapReq = () => ({
  url: RESOURCE_MANAGEMENT,
  method: 'get',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

export const getResourceManagementExportRequest = () => ({
  url: RESOURCE_MANAGEMENT_EXPORT,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});

export const getResourceMgmtEmployeeFilterReq = () => ({
  url: RESOURCE_MANAGEMENT_FILTER,
  method: 'post',
  headers: { 'content-type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  service: serviceName.PROJECT_MS,
});
